import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";

export class VehiclesDisplayListCtrl implements IController {

  ids: any;
  isRow: any;
  rowLimit: any;

  onChange: Function;

  private vehiclesRef: any;
  private displayItems: any;

  /* @ngInject */
  constructor(private $vehicles, private $log) {
  }

  $onInit() {
    this.vehiclesRef = this.$vehicles();

    if (!this.rowLimit) {
      this.rowLimit = 10;
    }

    this.setItems(this.ids);
  }

  $onChanges(changes) {
    if (changes.ids && !changes.ids.isFirstChange()) {
      this.setItems(this.ids);
    }
  }

  onRemoveItem(id) {
    this.onChange({ids: _.filter(this.ids, (i) => {return i !== id})});
  }

  onReset() {
    this.onChange({ids: []});
  }

  private setItems(ids) {
    if (ids && ids.length) {
      this.vehiclesRef.$asyncValues(ids)
        .then((vehicleTypes) => {
          const displayItems = [];
          _.forEach(vehicleTypes, (v) => {
            displayItems.push({id: v.id, value: v.name})
          })
          this.displayItems = displayItems;
        })
        .catch((error) => {
          this.$log.error('Failed to get branches', error);
        })
    } else {
      this.displayItems = [];
    }
  }

}

angular
  .module('bringoz.admin.vehicles')
  .component('vehiclesDisplayList', {
    bindings: {
      ids: '<',
      isRow: '<?',
      rowLimit: '<?',
      onChange: '&'
    },
    template: require('./vehicles-display-list.html').default,
    controller: VehiclesDisplayListCtrl
  });
